import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import CardContent from '@material-ui/core/CardContent'
import CardHeader  from '@material-ui/core/CardHeader'
import Grid        from '@material-ui/core/Grid'

import { Contact }      from '../../api'
import { LabelledText } from '../atoms'

const ContactCard = (props: Contact) => {
  return (
    <>
      <CardHeader
        title={props.name}
        subheader={(
          <>
            <FormattedMessage id={'sectors.' + props.sector} />
            {
              ', '
              + props.position
              + ', '
              + props.company
            }
          </>
        )}
      />
      <CardContent>
        <Grid container spacing={40}>
          <Grid item>
            <LabelledText label={<FormattedMessage id={'labels.email'} />}>
              {props.email}
            </LabelledText>
          </Grid>
          <Grid item>
            <LabelledText label={<FormattedMessage id={'labels.mobile'} />}>
              {props.mobile}
            </LabelledText>
          </Grid>
          <Grid item>
            {props.phone && (
              <LabelledText label={<FormattedMessage id={'labels.phone'} />}>
                {props.phone}
              </LabelledText>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </>
  )
}

export default ContactCard



// WEBPACK FOOTER //
// ./src/components/molecules/ContactCard.tsx